/**************************************************
 * Nombre:       Seccion_Profesional
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Profesional_Detalle from "./Componentes/Profesional_Detalle";
import Profesional_Registro_Educacion from "./Componentes/Profesional_Registro_Educacion";
import {useEffect, useState} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import {useParams} from "react-router";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";

const Seccion_Profesional = () => {
    const parms = useParams()
    const [profesional, setProfesional] = useState({});

    useEffect(() => {
        irArriba()

        if (parms && parms.id) {

            obtenerDoc('profesionales', parms.id).then(doc => {
                setProfesional(doc.data);
            })

        }


    }, [parms]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Profesional_Detalle item={profesional} />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Profesional_Registro_Educacion item={profesional} />
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Profesional